import React from "react";
import PropTypes from "prop-types";
import { useNavigate } from "react-router-dom";
import collaborationIconLeft from "../../Assests/collaboration-icon-left.png";
import collaborationIconRight from "../../Assests/collaboration-icon-right.png";
import Wallet from "../../Assests/Wallet.png";
import Question1 from "../../Assests/Question1.png";
import Question2 from "../../Assests/Question2.png";
import { createStripeAccount } from "../../Services/PaymentsApi";
import TermsAndConditions from "../TermsAndConditions/TermsAndConditions";

const PaymentTable = ({ data, activeKebab, setActiveKebab, popupRef, kebab, kebabActive, statusPaid, statusFailed, statusPending, statusRefunded, receiptIcon, rebookIcon, issueIcon, paymentType, showEmptyTable = false }) => {
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = React.useState(false);
    const [showTermsPopup, setShowTermsPopup] = React.useState(false);
    const [isTermsAnimating, setIsTermsAnimating] = React.useState(false);
    const [hoveredQuestion, setHoveredQuestion] = React.useState(null);
    const [tooltipPosition, setTooltipPosition] = React.useState({ top: 0, left: 0 });

    const handleAcceptTerms = async () => {
        try {
            setIsLoading(true);
            setIsTermsAnimating(false);
            setTimeout(() => setShowTermsPopup(false), 500);
            const response = await createStripeAccount();
            if (response.data.url) {
                window.open(response.data.url, '_blank');
            }
        } catch (error) {
            console.error('Failed to create Stripe account:', error);
        } finally {
            setIsLoading(false);
        }
    };

    const handleDeclineTerms = () => {
        setIsTermsAnimating(false);
        setTimeout(() => setShowTermsPopup(false), 500);
    };

    const handleShowTerms = () => {
        setShowTermsPopup(true);
        setTimeout(() => setIsTermsAnimating(true), 10);
    };
    if (!data || data.length === 0) {
        if (paymentType === 'Sent Payments') {
            return <div className="collaboration-card">
                <div className="collaboration-icon-container">
                    <img src={collaborationIconLeft} />
                    <img src={collaborationIconRight} />
                </div>
                <div className="collaboration-message">
                    No Collaborations Yet
                </div>
                <div className="collaboration-subtext">
                    Once you pay podcasters you collaborate with, those payments will appear here.
                </div>
                <button className="collaboration-button" onClick={() => navigate('/community')}>Find Podcaster</button>
            </div>;
        } else if (showEmptyTable) {
            const emptyHeaders = ['Sender', 'Amount', 'Date', 'Status'];
            return (
                <div style={{ marginTop: '2.22vh', height: '50vh' }}>
                    <table className="payment-table">
                        <thead>
                            <tr>
                                {emptyHeaders.map((header) => (
                                    <th key={header}>{header}</th>
                                ))}
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td colSpan={emptyHeaders.length} style={{ textAlign: 'center', padding: '3.70vh', color: 'rgba(255, 255, 255, 0.6)', fontSize: '1.48vh' }}>
                                    No received payments yet
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            );
        } else {
            return <div className="payment-card">
                <div className="payment-icon">
                    <img src={Wallet} />
                </div>
                <div className="payment-message">
                  No Received Payments Yet  
                </div>
                <div className="payment-subtext">
                   When other podcasters pay you for collaborations, you’ll see those payments here.
                </div>
                <button className="payment-button" disabled={isLoading} onClick={handleShowTerms}>
                    {isLoading ? 'Loading...' : 'Set Up Stripe'}
                </button>
                <TermsAndConditions
                    isOpen={showTermsPopup}
                    isAnimating={isTermsAnimating}
                    onAccept={handleAcceptTerms}
                    onDecline={handleDeclineTerms}
                    onClose={handleDeclineTerms}
                />
            </div>;
        }
    }
    const headers = Object.keys(data[0]);
    const getTooltipText = (status, row) => {
        const isSender = paymentType === 'Sent Payments';
        switch (status.toLowerCase()) {
            case "approved":
                return isSender 
                    ? "Approved, Money captured from bank account."
                    : "Approved, ready to receive funds transfer";
            case "paid":
                return "Money is now in Stripe's system (not yet transferred to receiver)";
            case "processing":
                return "Waiting for the next step (transfer to receiver's bank account)";
            case "failed":
                return isSender 
                    ? "Payment failed. Please retry - check card details or funds."
                    : "Payment failed. Sender notified to retry.";
            case "transferring":
                return isSender 
                    ? "Money already captured by Stripe.."
                    : "Funds moving from Stripe to receiver's Stripe account";
            case "successful":
                return "Funds have been sent to your bank and should appear within 1–2 business days.";
            case "underreview":
                return isSender 
                    ? "Money still held on card during fraud check"
                    : "Payment under fraud investigation, no transfer yet";
            case "refunded":
                return isSender 
                    ? "Hold released, money returned to bank account"
                    : "Payment rejected, no funds will be received";
            case "blocked":
                return "Stripe blocked this payment as too risky.";        
            default:
                return "";
        }
    };

    const shouldShowQuestionIcon = (status) => {
        const isSender = paymentType === 'Sent Payments';
        // Hide question icon for sender when status is successful
        if (isSender && status.toLowerCase() === 'successful') {
            return false;
        }
        return true;
    };

    const getStatusIcon = (status) => {
        switch (status.toLowerCase()) {
            case "pending":
            case "processing":
            case "transferring":
            case "under review":
                return statusPending;
            case "paid":
            case "successful":
                return statusPaid;
            case "blocked":
                return statusFailed;
            case "refunded":
                return statusRefunded;
            default:
                return statusPending;
        }
    };

    const getStatusLabel = (status) => {
        if (!status) return '';
        return status.charAt(0).toUpperCase() + status.slice(1).toLowerCase();
    };

    const renderStatus = (status, rowIndex, row) => {
        const icon = getStatusIcon(status);
        const label = getStatusLabel(status);
        const tooltipText = getTooltipText(status, row);
        const showQuestionIcon = shouldShowQuestionIcon(status);
        
        return (
            <span className="status-cell">
                {icon && <img src={icon} alt={label} style={{ width: '2.04vh', height: '2.04vh', marginRight: '0.93vh' }} />}
                {label}
                {showQuestionIcon && (
                    <span className="question-icon-wrapper">
                        <img 
                            src={hoveredQuestion === rowIndex ? Question2 : Question1} 
                            alt="Info" 
                            className="question-icon"
                            onMouseEnter={(e) => {
                                const rect = e.target.getBoundingClientRect();
                                setTooltipPosition({
                                    top: rect.bottom + 8,
                                    left: rect.left + rect.width / 2 - 180
                                });
                                setHoveredQuestion(rowIndex);
                            }}
                            onMouseLeave={() => setHoveredQuestion(null)}
                        />
                        {hoveredQuestion === rowIndex && tooltipText && (
                            <span 
                                className="status-tooltip"
                                style={{ top: tooltipPosition.top, left: tooltipPosition.left }}
                            >
                                {tooltipText}
                            </span>
                        )}
                    </span>
                )}
            </span>
        );
    };
    return (
        <div className="payment-table-container">
            <table className="payment-table">
                <thead>
                    <tr>
                        {headers.map((header) => (
                            <th key={header}>{header.replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase())}</th>
                        ))}
                    </tr>
                </thead>
                <tbody>
                    {data.map((row, index) => (
                        <tr key={row.id}>
                            {headers.map((header) => {
                                let cellContent;
                                if (header.toLowerCase() === "status") {
                                    cellContent = renderStatus(row[header], index, row);
                                } else if (header.toLowerCase() === "actions") {
                                    cellContent = (
                                        <div style={{position: 'relative', display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                                            <button
                                                type="button"
                                                onClick={() => setActiveKebab(activeKebab === index ? null : index)}
                                                style={{ background: 'none', border: 'none', padding: 0, margin: 0, cursor: 'pointer' }}
                                                aria-label="Open actions menu"
                                            >
                                                <img
                                                    src={activeKebab === index ? kebabActive : kebab}
                                                    alt="kebab menu"
                                                    className="action-dots"
                                                    style={{ width: '2.22vh', height: '2.22vh' }}
                                                />
                                            </button>
                                            {activeKebab === index && (
                                                <div className="action-popup" ref={popupRef}>
                                                    <div className="action-popup-row">
                                                        View Receipt <img src={receiptIcon} alt="receipt" />
                                                    </div>
                                                    <div className="action-popup-row">
                                                        Rebook <img src={rebookIcon} alt="rebook" />
                                                    </div>
                                                    <div className="action-popup-row">
                                                        Report Issue <img src={issueIcon} alt="issue" />
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                    );
                                } else {
                                    cellContent = row[header];
                                }
                                return (
                                    <td key={header} style={header.toLowerCase() === "actions" ? { position: 'relative' } : {}}>
                                        {cellContent}
                                    </td>
                                );
                            })}
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};

PaymentTable.propTypes = {
    data: PropTypes.arrayOf(PropTypes.object).isRequired,
    activeKebab: PropTypes.number,
    setActiveKebab: PropTypes.func.isRequired,
    popupRef: PropTypes.shape({ current: PropTypes.instanceOf(Element) }),
    kebab: PropTypes.string.isRequired,
    kebabActive: PropTypes.string.isRequired,
    statusPaid: PropTypes.string.isRequired,
    statusFailed: PropTypes.string.isRequired,
    statusPending: PropTypes.string.isRequired,
    statusRefunded: PropTypes.string.isRequired,
    receiptIcon: PropTypes.string.isRequired,
    rebookIcon: PropTypes.string.isRequired,
    issueIcon: PropTypes.string.isRequired,
    paymentType: PropTypes.string.isRequired,
    showEmptyTable: PropTypes.bool,
};

export default PaymentTable;